import { Checkbox } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const DynamicFieldCheckbox = ({ value, onChange, ...props }) => {
  return <Checkbox checked={value} onChange={onChange} {...props} />;
};

DynamicFieldCheckbox.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default memo(DynamicFieldCheckbox);
